export const SELECTED_CATEGORY = "SELECTED_CATEGORY";
export const SELECTED_TEST = "SELECTED_TEST";
